var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from '../component';
import { ComponentEventType } from '../componentEvent';
import { ContainerCommunicationHandlerMethods } from './communications/index';
/**
 * Child component base class.
 */
var ChildComponent = /** @class */ (function (_super) {
    __extends(ChildComponent, _super);
    /**
     * Constructor.
     *
     * @param window The window reference.
     * @param options The child options.
     * @param rootFacade The facade to the root component.
     */
    function ChildComponent(window, options, rootFacade) {
        var _this = _super.call(this, window, options) || this;
        _this.rootFacade = rootFacade;
        _this.communicationHandler = null;
        _this.contentDisposePromise = null;
        _this.contentDisposePromiseResolver = null;
        return _this;
    }
    /**
     * Get the communication handler.
     */
    ChildComponent.prototype.getCommunicationHandler = function () {
        var _this = this;
        var methods = new ContainerCommunicationHandlerMethods();
        methods.mounted = function () { return _this.callHandler(ComponentEventType.Mounted); };
        methods.beforeUpdate = function () { return _this.callHandler(ComponentEventType.BeforeUpdate); };
        methods.updated = function () { return _this.callHandler(ComponentEventType.Updated); };
        methods.data = function (data) { return _this.callHandler(ComponentEventType.Data, data); };
        methods.beforeDispose = function () { return _this.contentBeginDisposed(); };
        methods.disposed = function () { return _this.contentDisposed(); };
        return this.getCommunicationHandlerCore(methods);
    };
    /**
     * Get the child component options.
     */
    ChildComponent.prototype.getOptions = function () {
        return _super.prototype.getOptions.call(this);
    };
    /**
     * Handler for the signal that the component started to dispose.
     */
    ChildComponent.prototype.contentBeginDisposed = function () {
        if (this.contentDisposePromise !== null)
            return; // Dispose has already started.
        this.setContentDisposePromise();
        // Inform parent the content is being disposed.
        this.rootFacade.signalDisposed(this);
    };
    /**
     * Signal the content that it will be disposed.
     */
    ChildComponent.prototype.startDisposingContent = function () {
        if (this.contentDisposePromise !== null)
            return; // Dispose has already started.
        this.setContentDisposePromise();
        // This should trigger the child component dispose.
        this.communicationHandler.requestContentDispose();
    };
    /**
     * Set the promise that is used fof the disposing of the component.
     */
    ChildComponent.prototype.setContentDisposePromise = function () {
        var _this = this;
        this.contentDisposePromise = Promise
            .race([
            new Promise(function (resolver) {
                _this.contentDisposePromiseResolver = resolver;
            }),
            new Promise(function (resolveTimeout, rejectTimeout) {
                _this
                    .getWindow()
                    .setTimeout(function () { return rejectTimeout(new Error('Child dispose timeout.')); }, _this.getOptions().contentDisposeTimeout);
            })
        ])
            .catch(function (err) {
            _this.callErrorHandler(err);
        });
    };
    /**
     * Handler for the signal that the content has finished disposing.
     */
    ChildComponent.prototype.contentDisposed = function () {
        if (this.contentDisposePromiseResolver === null) {
            // For some reason we got the disposed call without getting the 'beginDispose' call.
            this.contentDisposePromise = Promise.resolve();
            this.rootFacade.signalDisposed(this);
        }
        else {
            this.contentDisposePromiseResolver();
        }
    };
    /**
     * @@inheritdoc
     */
    ChildComponent.prototype.mountCore = function () {
        if (!this.communicationHandler) {
            this.communicationHandler = this.getCommunicationHandler();
        }
        return _super.prototype.mountCore.call(this);
    };
    /**
     * @@inheritdoc
     */
    ChildComponent.prototype.disposeCore = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.startDisposingContent();
                        return [4 /*yield*/, this.contentDisposePromise];
                    case 1:
                        _a.sent();
                        this.communicationHandler.dispose();
                        this.communicationHandler = null;
                        this.contentDisposePromiseResolver = null;
                        this.contentDisposePromise = null;
                        return [4 /*yield*/, _super.prototype.disposeCore.call(this)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Send data.
     *
     * @param data The data to send.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    ChildComponent.prototype.sendData = function (data) {
        var _a;
        (_a = this.communicationHandler) === null || _a === void 0 ? void 0 : _a.sendData(data);
    };
    return ChildComponent;
}(Component));
export { ChildComponent };
//# sourceMappingURL=childComponent.js.map